import { CustomerModel } from "@crypto-payment-gateway/models"
import { apiPrivate } from "./interceptors"

export async function getCustomers(
	user_id: string
): Promise<CustomerModel[] | undefined> {
	const res = await apiPrivate.get(`/customers/?user_id=${user_id}`)
	return res.data?.data?.customers
}
